/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { InputHTMLAttributes } from 'react';
import styled from '@emotion/styled';
import ThemeTypes from 'common/types/ThemeTypes';
import { useTheme } from '@emotion/react';
const StyledTextArea = styled.textarea`
    outline: none;
    border: none;
    border: 1px solid ${(props: StyledTextAreaProps) => props.error ? props.theme.colors.error : props.theme.colors.gray};
    border-radius: 8px;
    background-color: ${(props) => props.theme.colors.secondaryColor};
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 1px;
    color: ${(props) => props.theme.colors.primaryTextColor};
    height: ${(props) => props.height || '84px'};
    padding: 10px 16px;
    transition: border-color 0.2s ease-in-out;
    resize: ${(props) => props.resize || 'none'};
    &::placeholder {
        color: ${(props) => props.theme.colors.gray};
    }
    &:focus {
        border-color: ${(props) => props.theme.colors.primaryColor};
    }
    &::-webkit-scrollbar {
      width: 14px;
      padding: 15px 0;
      transform: scale(0.5);
    }
    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(64, 108, 255, 0.10);
      border-radius: 20px;
      border: 3px solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
    }
`;

type TextAreaProps = {
  placeholder?: string,
  value: string,
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void,
  props?: InputHTMLAttributes<HTMLTextAreaElement>,
  error?: boolean | string,
  className?: string,
  name?: string,
  height?: string | number,
  resize?: 'none' | 'both' | 'horizontal' | 'vertical' | 'block' | 'inline',
};

type StyledTextAreaProps = {
  error: boolean | string,
  theme: ThemeTypes,
  height?: string | number,
  resize?: 'none' | 'both' | 'horizontal' | 'vertical' | 'block' | 'inline',
} & InputHTMLAttributes<HTMLTextAreaElement>;

export default function TextArea({ placeholder, onChange, value, props, error, className, name, height, resize }: TextAreaProps): JSX.Element {
  const theme = useTheme();
  return (
    <StyledTextArea theme={theme} name={name} error={error} value={value} onChange={onChange} resize={resize} height={height} className={className} placeholder={placeholder} {...props} />
  );
}

